"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BackInStockNotificationController = require("./BackInStockNotificationController");
Object.keys(_BackInStockNotificationController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BackInStockNotificationController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BackInStockNotificationController[key];
    }
  });
});